

export default {
  components: {
    'id-diagram-lazy-related': () => import('~/components/diagram/lazy/Related.vue'),
    'id-diagram-lazy-buy-info': () => import('~/components/diagram/lazy/BuyInfo.vue'),
    'id-diagram-lazy-value-description': () => import('~/components/diagram/lazy/ValueDescription.vue'),
    'id-diagram-lazy-license-selector': () => import('~/components/diagram/lazy/LicenseSelector.vue'),
    'id-diagram-lazy-buy-buttons': () => import('~/components/diagram/lazy/BuyButtons.vue'),
    'id-diagram-lazy-contact-to-buy': () => import('~/components/diagram/lazy/ContactToBuy.vue'),
    'id-free-diagram-lazy-form': () => import('~/components/free-diagram/lazy/Form.vue')
  },
  props: {
    diagram: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    license: null,
    frequentlyBought: [],
    related: [],
    licences: []
  }),
  fetchOnServer: false,
  async fetch () {
    this.frequentlyBought = (await this.$serverBackend.get(`/diagrams/${this.diagram.id}/frequently_bought`)).results || []
    this.related = (await this.$serverBackend.get(`/diagrams/${this.diagram.id}/related`)).results
    this.licences = (await this.$serverBackend.get('/licenses')).results
  },
  computed: {
    nonFree () {
      return this.frequentlyBought.filter(d => d.price > 0)
    },
    showFrequentlyBought () {
      return this.nonFree && this.nonFree.length > 2
    }
  },
  methods: {
    setLicense ({ license }) {
      this.license = license
    }
  }
}
